import React from 'react';
import { connect } from 'react-redux';

import BaseLayout from 'apps/auth/components/common/Layout/BaseLayout';
import { InfoPage } from 'apps/auth/components/common/Layout/InfoPage/InfoPage';
import BasePage from 'apps/auth/components/utils/BasePage';
import { AUTH_SEND_MAIN_LINK } from 'apps/auth/constants/UrlConstants';

const GTStubPage = (props) => {
    return (
        <BaseLayout>
            <InfoPage
                topButtonType={'link'}
                topButtonCaption={props.notNow}
                topButtonOnClick={(e) => {
                    e.preventDefault();
                    window.history.back();
                }}
                topButtonLink={AUTH_SEND_MAIN_LINK}
                iconName={'paysend-logo-globe'}
                iconColor={'primary'}
                headerText={props.title}
                secondaryText={props.info}
                primaryButtonCaption={props.getApp}
                primaryButtonType={'link'}
                primaryButtonLink={props.appLink}
            />
        </BaseLayout>
    );
};

const mapStateToProps = (state) => {
    return {
        appLink: state.extra.appLink,
        title: state.messages.pageMessages.stubPageTitle,
        info: state.messages.pageMessages.stubPageInfo,
        getApp: state.messages.pageMessages.stubPageGetApp,
        notNow: state.messages.pageMessages.stubPageNotNow,
    };
};

export default connect(mapStateToProps)(BasePage(GTStubPage));
